import {
  UserProfileType,
  SalaryType,
  Maybe,
} from '@/lib/generated/graphql-types'
import { SalaryFilterParam } from '../constants'
import { SalaryFilterControl } from '../constants'
import { OnboardingAccountType } from '@/modules/surveys/configs/onboarding/constants'
import {
  NURSE_PRACTITIONER_ID,
  NURSE_PRACTITIONER_SLUG,
  PHYSICIAN_ASSISTANT_ID,
  PHYSICIAN_ASSISTANT_SLUG,
  PHYSICIAN_SLUG,
} from '@/modules/surveys/configs/onboarding/personal-info-config'

export function getDefaultSalaryFilterUrlParams({
  baseSpecialtyId,
  professionSlug,
  professionId,
  occupationSlug,
}: {
  baseSpecialtyId?: string
  professionSlug?: string
  professionId?: string
  occupationSlug?: string
}) {
  const urlParams = new URLSearchParams()
  if (baseSpecialtyId) {
    urlParams.set(SalaryFilterControl.specialty, baseSpecialtyId)
  }
  if (professionSlug) {
    urlParams.set(SalaryFilterControl.profession, professionSlug)
  }
  if (professionId) {
    urlParams.set(SalaryFilterControl.profession, professionId)
  }
  if (occupationSlug) {
    urlParams.set(SalaryFilterParam.occupation, occupationSlug)
  }
  return urlParams
}

export function getSalaryFiltersFromUserProfile(opts: {
  userProfile: Maybe<UserProfileType> | undefined
}) {
  const { userProfile } = opts
  const isStudent =
    userProfile?.onboardingType === OnboardingAccountType.Student
  const professionSlug = isStudent
    ? PHYSICIAN_SLUG
    : userProfile?.occupation?.profession?.slug
  const isNpOrPa =
    professionSlug === PHYSICIAN_ASSISTANT_SLUG ||
    professionSlug === NURSE_PRACTITIONER_SLUG
  const baseSpecialtyId = isNpOrPa
    ? null
    : userProfile?.occupation?.specialty?.baseSpecialtyId

  return {
    specialtyId: baseSpecialtyId,
    professionSlug,
    occupationSlug: userProfile?.occupation?.slug,
  }
}

export function getSalaryFiltersFromSurveyReview(
  getSurveyReview: Maybe<SalaryType> | undefined,
) {
  const professionId = getSurveyReview?.occupation?.professionId
  const occupationSlug = getSurveyReview?.occupation?.slug
  const isNpOrPa =
    professionId === PHYSICIAN_ASSISTANT_ID ||
    professionId === NURSE_PRACTITIONER_ID
  const baseSpecialtyId = isNpOrPa
    ? null
    : getSurveyReview?.occupation?.specialty?.baseSpecialtyId
  const urlParams = getDefaultSalaryFilterUrlParams({
    baseSpecialtyId,
    professionId,
  })
  return { baseSpecialtyId, professionId, urlParams, occupationSlug }
}
